document.addEventListener('DOMContentLoaded', function () {

    const section = document.querySelector(
        '.section-team-vitality-partner'
    );

    if (!section) return;

    const videoButton = section.querySelector(
        '[data-youtube-id]'
    );

    const modal = section.querySelector(
        '[data-youtube-modal]'
    );

    const iframe = section.querySelector(
        '[data-youtube-iframe]'
    );

    const closeButtons = section.querySelectorAll(
        '[data-youtube-close]'
    );

    if (!videoButton || !modal || !iframe) return;

    const youtubeId = videoButton.dataset.youtubeId;

    // 打开视频
    videoButton.addEventListener('click', function () {

        iframe.src =
        'https://www.youtube-nocookie.com/embed/' +
        youtubeId +
        '?autoplay=1&rel=0';

        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden', 'false');

        document.body.classList.add(
        'team-vitality-video-open'
        );
    });

    // 关闭视频
    closeButtons.forEach(function (button) {

        button.addEventListener('click', closeModal);

    });

    function closeModal() {

        modal.classList.remove('is-active');
        modal.setAttribute('aria-hidden', 'true');

        // 停止视频
        iframe.src = '';

        document.body.classList.remove(
        'team-vitality-video-open'
        );
    }

    // ESC 关闭
    document.addEventListener('keydown', function (event) {

        if (
        event.key === 'Escape' &&
            modal.classList.contains('is-active')
        ) {
            closeModal();
        }

    });

});